<template>
  <transition name="modal-fade">
    <div class="modal-overlay" v-if="isVisible">
      <div class="modal-content">
        <button class="close-btn" @click="fecharModal">&times;</button>

        <div class="modal-header icon-circle">
          <img :src="iconInfo" alt="Ícone de informação" />
          Aviso de manutenção técnica
        </div>

        <div class="modal-body">
          <p>
            No dia <strong>19/05 (das 6h às 16h)</strong>, o Portal de Laudos
            estará em manutenção.
          </p>
          <p>
            Mas não se preocupe: nosso atendimento continuará ativo via
            <strong>WhatsApp 0800 048 3500</strong>.
          </p>
        </div>

        <div class="modal-footer">
          <button class="btn-continue" @click="fecharModal">
            Continuar para o Portal
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import imagemInfo from "../assets/imagens/icon-info.svg";
import { obterJsonManutencao } from "../http/configuracoes";

export default {
  name: "ManutencaoModal",
  data() {
    return {
      isVisible: false,
      iconInfo: imagemInfo,
    };
  },
  async mounted() {
    try {
      const response = await obterJsonManutencao();

      if (response.ok) {
        const config = await response.json();
        const dataAtual = new Date();
        const dataLimite = new Date(config.dataLimiteAviso);

        this.isVisible = dataAtual <= dataLimite;
      }
    } catch (error) {
      console.error("Erro ao carregar configuração de manutenção:", error);
      this.isVisible = false;
    }
  },
  methods: {
    fecharModal() {
      this.isVisible = false;
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  background-color: #ffffff;
  width: 500px;
  border-radius: 4px;
  padding: 0 0 0 0;
  position: relative;
  border: 1px solid #dcdcdc;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  color: #333;
}

.close-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  font-size: 22px;
  font-weight: bold;
  color: #888;
  cursor: pointer;
  line-height: 1;
}

.close-btn:hover {
  color: #555;
}

.modal-header {
  color: #212529;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-bottom: none;
  font-size: 20px;
  font-weight: 400;
}

.icon-circle img {
  width: 64px;
  height: 64px;
  background-color: #f47920;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 32px;
  box-shadow: 0 0 0 6px #fde4d0;
}

.info-icon {
  color: #ffffff;
  font-size: 38px;
}

h2 {
  font-size: 19px;
  font-weight: normal;
  margin: 0;
  color: #222;
  text-align: center;
}

.modal-body {
  font-size: 16px;
  line-height: 1.5;
  color: #212529;
  text-align: left;
  margin-bottom: 0;
}

.modal-body p {
  margin: 0 0 20px 0;
}

.modal-body p:last-child {
  margin-bottom: 0;
}

.modal-footer {
  text-align: right;
  border-top: 1px solid #eaeaea;
}

.btn-continue {
  background-color: #00844f;
  color: #ffffff;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 15px;
  cursor: pointer;
}

.btn-continue:hover {
  background-color: #006b40;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}
</style>
